module.exports = __webpack_public_path__ + "img/Thumnail3.54998633.svg";